<template>
  <div class="link-buttons">
    <button
      @click="openLinkModal"
      :class="{ 'is-active': editor.isActive('link') }"
      title="Set Link"
    >
      <img src="/images/tiptap-bar/link.svg" alt="Link" />
    </button>
    <button
      v-if="editor.isActive('link')"
      @click="editor.chain().focus().unsetLink().run()"
      :disabled="!editor.can().chain().focus().unsetLink().run()"
      title="Unlink"
    >
      <img src="/images/tiptap-bar/unlink.svg" alt="Unlink" />
    </button>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

defineProps({
  editor: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["open-link-modal"]);

const openLinkModal = () => {
  emit("open-link-modal");
};
</script>

<style scoped>
.link-buttons {
  display: flex;
  gap: 5px;
}
</style>
